<template>
  <div class="candidate-number" :class="`page-${page}`">
    <section
      v-b-popover.hover.top="{
        content: 'Review in progress by the CS team.',
      }"
      class="text"
      :class="`reviewing-${page}`"
    >
      <i v-if="page === 'index'" class="las la-sitemap"></i>
      <i v-if="page === 'show'" class="las la-glasses"></i>
      <p>REVIEW :</p>
      <span class="number">{{ job.candidateReviewingCount }}</span>
    </section>

    <section class="processing-group">
      <span v-if="page === 'show'">
        <i class="las la-sitemap"></i>
      </span>

      <span
        v-b-popover.hover.top="{
          content: 'Resumes sent. Waiting for client feedback.',
        }"
        class="text under-selection"
      >
        UNDER SELECTION :
        <span class="number">{{ job.candidateUnderSelectionCount }}</span>
      </span>

      <span
        v-b-popover.hover.top="{
          content: 'Candidates are in interview or offer stage.',
        }"
        class="text on-going"
      >
        ON GOING:
        <span class="number">{{ job.candidateOnGoingCount }}</span></span
      >
    </section>
  </div>
</template>

<script>
import { VBPopover } from 'bootstrap-vue'

export default {
  name: 'CandidateProcessNumber',

  directives: {
    'b-popover': VBPopover,
  },

  props: {
    job: {
      type: Object,
      required: true,
    },
    page: {
      type: String,
      required: false,
      default: 'show',
    },
  },
}
</script>

<style scoped lang="scss">
@import 'stylesheets/global';

.candidate-number {
  align-items: baseline;
  color: $black;
  display: flex;
  font-size: 1em;

  @include sp {
    font-size: 10px;
    min-width: 220px;
  }

  &.page-index {
    display: flex;
  }

  &.page-show {
    display: block;
  }

  i {
    color: #3742fa;
    font-size: 20px;
    margin-right: 10px;
    margin-top: 3px;

    @include sp {
      font-size: 16px;
    }
  }

  .text {
    font-weight: 500;
    margin-right: 10px;
    width: fit-content;

    @include sp {
      margin-right: 5px;
    }

    &.reviewing-index {
      align-items: baseline;
      display: flex;

      p {
        font-weight: 500;
        margin-right: 5px;
      }

      .number {
        color: #e7b500;
        font-weight: bolder;
      }
    }
    &.reviewing-show {
      align-items: baseline;
      display: flex;

      p {
        font-weight: 500;
        margin-right: 5px;
      }

      .number {
        color: #e7b500;
        font-weight: bolder;
      }
    }
    &.under-selection {
      .number {
        color: #f76400;
        font-weight: bolder;
      }
    }
    &.on-going {
      .number {
        color: #3742fa;
        font-weight: bolder;
      }
    }
  }

  .processing-group {
    align-items: baseline;
    display: flex;
    flex-direction: row;
  }
}
</style>
